// @file utils for safe area insets
import { EdgeInsets } from '@@/bits/window'

export const setSafeAreaInsets = (safeAreaInsets: EdgeInsets): void => {
  if (typeof document.documentElement.style.setProperty === 'function') {
    document.documentElement.style.setProperty('--safe-area-inset-top', `${safeAreaInsets.top}px`)
    document.documentElement.style.setProperty('--safe-area-inset-left', `${safeAreaInsets.left}px`)
    document.documentElement.style.setProperty('--safe-area-inset-right', `${safeAreaInsets.right}px`)
    document.documentElement.style.setProperty('--safe-area-inset-bottom', `${safeAreaInsets.bottom}px`)
  }
}

export const getSafeAreaInsets = (): Record<keyof EdgeInsets, string> => {
  const top = getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-top')
  const left = getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-left')
  const right = getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-right')
  const bottom = getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-bottom')

  return {
    top,
    left,
    right,
    bottom,
  }
}
